export default __webpack_public_path__ + "static/media/GA_Mix-2.ada85e70.wav";